import React, { useState } from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import ConsumerDurableLoan from "../../assets/Images/Home/ConsumerDurableLoan.jpg";
import ruppesIcon from "../../assets/Images/Home/ruppesIcon.jpg";

import TextImageSection from "../Home/component/TextImageSection";

import HomeImprovementLoan from "../../assets/Images/Home/HomeImprovementLoan.jpg";

import MedicalLoan from "../../assets/Images/Home/MedicalLoan.jpg";
import TravelLoan from "../../assets/Images/Home/TravelLoan.jpg";
import HighEndElectronicsLoan from "../../assets/Images/Home/HighEndElectronicsLoan.jpg";
import WeddingLoan from "../../assets/Images/Home/WeddingLoan.jpg";

import FestiveLoan from "../../assets/Images/Home/FestiveLoan.jpg";
import EducationLoan from "../../assets/Images/Home/EducationLoan.jpg";
import ShoppingLoan from "../../assets/Images/Home/ShoppingLoan.jpg";
import EmergencyLoan from "../../assets/Images/Home/EmergencyLoan.jpg";
import LifestyleLoans from "../../assets/Images/Home/LifestyleLoans.jpg";
import LoanModal from "../../components/loanModal/LoanModal";


export const LoanProductPage = () => {
  const Product = [
    {
      image: ConsumerDurableLoan,
      chipHeading: "Consumer Durable Loan",
      mainHeading: "Get the Essentials You Need with Ease",
      description:
        "Living comfortably feels great! Whether it's a smart TV, a cozy sofa, or a new air conditioner, quality products can enhance your day-to-day life. Don’t wait for your next paycheck to enjoy the comforts you deserve.",
      buttonHeading: "Apply now",
    },
    {
      image: HomeImprovementLoan,
      chipHeading: "Home Improvement Loan",
      mainHeading: "Enhance your home with easy financing options.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur ",
      buttonHeading: "Apply now",
    },
    {
      image: MedicalLoan,
      chipHeading: "Medical Loan",
      mainHeading: "We’re here for you when it matters most.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      buttonHeading: "Apply now",
    },
    {
      image: TravelLoan,
      chipHeading: "Travel Loan",
      mainHeading: "Discover new horizons with our easy travel financing.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur ",
      buttonHeading: "Apply now",
    },
    {
      image: HighEndElectronicsLoan,
      chipHeading: "High-End Electronics Loan",
      mainHeading: "Step Up Your Tech Game, Hassle-Free",
      description:
        "Living comfortably feels great! Whether it's a smart TV, a cozy sofa, or a new air conditioner, quality products can enhance your day-to-day life.",
      buttonHeading: "Apply now",
    },

    {
      image: WeddingLoan,
      chipHeading: "Wedding Loan",
      mainHeading: "Celebrate your special day without financial worry.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur ",
      buttonHeading: "Apply now",
    },

    {
      image: FestiveLoan,
      chipHeading: "Festive Loan",
      mainHeading: "Celebrate every moment with joy.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      buttonHeading: "Apply now",
    },

    {
      image: EducationLoan,
      chipHeading: "Education Loan",
      mainHeading: "To Bring Your Dream Home into reality.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      buttonHeading: "Apply now",
    },

    {
      image: ShoppingLoan,
      chipHeading: "Shopping Loan",
      mainHeading: "Step up your shopping game, hassle free.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      buttonHeading: "Apply now",
    },

    {
      image: EmergencyLoan,
      chipHeading: "Emergency Loan",
      mainHeading: "To Bring Your Dream Home into reality.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      buttonHeading: "Apply now",
    },

    {
      image: LifestyleLoans,
      chipHeading: "Lifestyle Loans",
      mainHeading: "To Bring Your Dream Home into reality.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      buttonHeading: "Apply now",
    },
  ];
  const[openModel,setmodalClose] = useState(false);
  const [openIndex,setopenIndex] = useState(null)
  const modalData = ()=>{
    // setmodalClose(true);
    return <LoanModal isOpen={openModel} onClose={()=>{setmodalClose(false)}}>
    <div className="loan-hr-container">
      <div className="image-container">
        <img src={Product[openIndex]?.image}></img>
      </div>
      <div className="loan-content-container">
        <div className="chip-heading">
          <h1>{Product[openIndex]?.chipHeading}</h1>
        </div>
        <div className="main-loan-container">
          <h1 className="heading-loan">{Product[openIndex]?.mainHeading}</h1>
          <p className="loan-description">{Product[openIndex]?.description}</p>
          <button
            onClick={() => alert("will get back to you soon...")}
            className="apply-button"
          >
            <span className="button-text">{Product[openIndex]?.buttonHeading}</span>
          </button>
        </div>
      </div>
    </div>
    </LoanModal>
  }
  return (
    <>
      <Navbar />
      <div className="loan-product-page">
        <TextImageSection
          view={"heading-then-image"}
          image={ruppesIcon}
          heading={"Quick Loans for Every Goals."}
          custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan loan-product-page"
        ></TextImageSection>

        <div className="loan-hr-product">
          {Product?.map((item,index) => (
            <>
            <div key ={index} className="loan-hr-container" onClick={()=>{setopenIndex(index);setmodalClose(true);}}>
              <div className="image-container">
                <img src={item?.image}></img>
              </div>
              <div className="loan-content-container">
                <div className="chip-heading">
                  <h1>{item?.chipHeading}</h1>
                </div>
                <div className="main-loan-container">
                  <h1 className="heading-loan">{item?.mainHeading}</h1>
                  <p className="loan-description">{item?.description}</p>
                  <button
                    onClick={() => alert("will get back to you soon...")}
                    className="apply-button"
                  >
                    <span className="button-text">{item?.buttonHeading}</span>
                  </button>
                </div>
              </div>
            </div>
            {modalData()}
            </>
            
            
          ))}
        </div>
      </div>

      <Footer custumeClass="landing-page-footer !bg-inherit !border-0" />
    </>
  );
};
